import { Text, View } from 'react-native'

// styles
import { globalStyles } from '../../../static/styles/global'
import { useTranslation } from 'react-i18next'

interface cardStatusProps {
  status:
  | 'NOT STARTED'
  | 'INCOMPLETE'
  | 'PENDING'
  | 'RESUBMIT'
  | 'COMPLETED'
  | 'VERIFY'
  | 'DECLINED',
  flat?: boolean,

}

const CardStatus = ({ status, flat = false }: cardStatusProps): JSX.Element => {
  //let badgeLabel: string
  let badgeStyle: {}
  let badgeTextStyle: {}
  const { t } = useTranslation()

  switch (status) {
    case 'NOT STARTED':
      //badgeLabel = 'Not Started'
      badgeStyle = globalStyles.badgeNotStarted
      badgeTextStyle = globalStyles.badgeTextNotStarted
      break
    case 'INCOMPLETE':
      // badgeLabel = 'Incomplete'
      badgeStyle = globalStyles.badgeIncompleted
      badgeTextStyle = globalStyles.badgeTextIncompleted
      break
    case 'PENDING':
      // badgeLabel = 'Pending Approval'
      badgeStyle = globalStyles.badgePending
      badgeTextStyle = globalStyles.badgeTextPending
      break
    case 'RESUBMIT':
      // badgeLabel = 'Resubmit'
      badgeStyle = globalStyles.badgeResubmit
      badgeTextStyle = globalStyles.badgeTextResubmit
      break
    case 'COMPLETED':
      //badgeLabel = 'Completed'
      badgeStyle = globalStyles.badgeCompleted
      badgeTextStyle = globalStyles.badgeTextCompleted
      break
    case 'VERIFY':
      //badgeLabel = 'Verify'
      badgeStyle = globalStyles.badgeVerify
      badgeTextStyle = globalStyles.badgeTextVerify
      break
    case 'DECLINED':
      //badgeLabel = 'Rejected'
      badgeStyle = globalStyles.badgePending
      badgeTextStyle = globalStyles.badgeTextPending
      break
  }
  const badgeLabel = t(`card_status.${status}`);
  return (
    <View
      style={[
        globalStyles.badge,
        badgeStyle,
        status === 'NOT STARTED' && flat && globalStyles.badgeFlat
      ]}
    >
      <Text style={[globalStyles.badgeText, badgeTextStyle]}>{badgeLabel}</Text>
    </View>
  )
}

export default CardStatus
